<template>
  <div class="resumeboxs flex">
    <div class="head-image">
      <img v-if="item.headImage" :src="item.headImage" alt=""/>
      <img src="//oss.51ztx.com/resu.png" v-else alt="">
    </div>
    <div class="flex-grow">
      <div class="tit-name flex">{{item.name}}
        <div v-if='item.type === 2' class="from-out">赴外招聘</div>
      </div>
      <template v-if="type === 'default'">
        <div class="tit-post flex">
          <!--<div class="m-r-16">应聘</div>-->
          <div class="m-r-16">{{item.recruitTitle}}</div>
          <div class="tit-sub" v-if="item.provideCarsubsidy*1 === 1">面试补贴</div>
        </div>
        <div class="flex detail-ls">
          <div v-if="item.sexName">{{item.sexName}}</div>
          <div v-if="item.age">{{item.age}}岁</div>
          <div v-if="item.educationName">{{item.educationName}}</div>
          <div v-if="item.homeProvincename">{{item.homeProvincename}}{{item.homeCityname}}</div>
        </div>
        <div class="time">
          <span v-if="tabindex === 0">{{item.deliverTime}}</span>
          <span v-if="tabindex === 1">{{item.inviteFaceTime}}</span>
          <span v-if="tabindex === 2">{{item.inviteOnTime}}</span>
          <span v-if="tabindex === 3">{{item.finishTime}}</span>
          <span v-if="tabindex === 4">{{item.finishTime}}</span>
        </div>
        <div class="resume-btn-groups" v-if="[0].includes(Number(tabindex))">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerDeliverId: item.id, recruitId: item.recruitId } }">
            简历详情
          </router-link>
          <div class="resumebtn primary-border-btn" @click.prevent="downloadResume" v-if="item.isColl === 0">
            下载简历
          </div>
          <div class="resumebtn primary-border-btn" @click.prevent v-else>
            已下载
          </div>
          <div class="resumebtn error-border-btn"
               v-if="[1, 2, 11, 12, 6].includes(item.status)"
               @click.prevent="qppRejectInterview(item.id)">
            不合适
          </div>
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 1">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerDeliverId: item.id, provideCarsubsidy: item.provideCarsubsidy, carsubsidy: item.carsubsidy, recruitId: item.recruitId } }">
            简历详情
          </router-link>
          <div class="resumebtn primary-border-btn"
               v-if="[1, 2, 11, 12].includes(item.status)"
               @click="appInterview(item.id)">
            约面试
          </div>
          <div class="resumebtn primary-border-btn"
               v-if="[1, 2, 11, 12, 4, 6].includes(item.status)"
               @click="appInterviewSuccess(item.id)">
            已上岗
          </div>
          <div class="resumebtn error-border-btn"
               v-if="[1, 2, 11, 12, 6].includes(item.status)"
               @click="qppRejectInterview(item.id)">
            不合适
          </div>
          <!--<div class="resumebtn error-border-btn"
               v-if="[4].includes(item.status)"
               @click="interviewReject(index)">
            不通过
          </div>
          <div class="resumebtn primary-btn"
               v-if="[4].includes(item.status)"
               @click="interviewPass(index)">
            通过
          </div>-->
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 2">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerDeliverId: item.id, recruitId: item.recruitId } }">
            查看详情
          </router-link>
          <div class="resumebtn primary-border-btn"
               v-if="[4].includes(item.status)"
               @click="interviewPass(index)">
            面试通过
          </div>
          <div class="resumebtn primary-border-btn"
               v-if="[1, 2, 11, 12, 4, 6].includes(item.status)"
               @click="appInterviewSuccess(item.id)">
            已上岗
          </div>
          <div class="resumebtn error-border-btn"
               v-if="[4].includes(item.status)"
               @click="interviewFailView(item.id)">
            不通过
          </div>
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 3">
          <!--<router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerDeliverId: item.id, recruitId: item.recruitId } }">
            查看详情
          </router-link>
          <div class="resumebtn error-border-btn" @click="deleteInterview(item.id)">删除</div>-->
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 5">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerId: item.id, recruitId: item.recruitId, isCol: true } }">
            查看详情
          </router-link>
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 6">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerId: item.workerId, recruitId: item.recruitId, isCol: true } }">
            查看详情
          </router-link>
        </div>
        <div class="resume-btn-groups" v-if="tabindex === 4">
          <router-link class="resumebtn primary-border-btn"
                       :to="{ path: '/index/resume/info', query: { workerDeliverId: item.id, recruitId: item.recruitId } }">
            查看详情
          </router-link>
          <div class="resumebtn primary-border-btn"
               v-if="[1, 2, 11, 12, 4, 6].includes(item.status)"
               @click="appInterviewSuccess(item.id)">
            已上岗
          </div>
          <div class="resumebtn error-border-btn"
               v-if="[6].includes(item.status)"
               @click="failPost(item.id)">
            未上岗
          </div>
        </div>
      </template>
      <template v-if="type === 'talent'">
        <div class="tit-post flex flex-between">
          <div class="flex" v-if="item.expectPositionname">
            <div class="light">求职意向：</div>
            <div>{{item.expectPositionname}}</div>
            <template v-if="item.expectCityname">
              <div class="v-line"></div>
              <div class="">{{item.expectCityname}}</div>
            </template>
          </div>
          <div class="flex" v-if="item.expectMinsalary">
            <div class="light">期待薪资：</div>
            ￥{{item.expectMinsalary}}~{{item.expectMaxsalary}}
          </div>
        </div>
        <div class="flex detail-ls">
          <div v-if="item.sexName">{{item.sex}}</div>
          <div v-if="item.age">{{item.age}}岁</div>
          <div v-if="item.education">{{item.education}}</div>
          <div v-if="item.homeCityname">{{item.homeCityname}}</div>
        </div>
      </template>
    </div>
    <div class="btn-ls" v-if="type === 'talent'">
      <router-link class="primary-btn"
                   :to="{path:'/index/searchlistInfo',query:{workerId:item.id, isCol: true}}"
                   target="_blank">
        查看简历
      </router-link>
      <div class="flex flex-center pointer" style="color: #333333; font-size: 14px;" @click="downloadResume">
        <template v-if="item.isColl === 0">
          <img style="width: 16px; height: 16px; margin-right: 6px;"
               src="../assets/images/resume/download_icon.png"
               alt="">
          下载简历
        </template>
        <template v-else>
          已添加
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'resume-item',
    props: {
      item: {
        type: Object,
        default: () => {
          return {}
        }
      },
      type: {
        type: String,
        default: 'default'
      },
      tabindex: {
        type: [Number, String],
        default: 0
      },
      index: {
        type: [Number, String],
        default: 0
      }
    },
    methods: {
      qppRejectInterview(id) {
        this.$emit('qppRejectInterview', id);
      },
      appInterview(id) {
        this.$emit('appInterview', id);
      },
      interviewPass(index) {
        this.$emit('interviewPass', index);
      },
      failPost(id) {
        this.$emit('failPost', id);
      },
      successPost(id) {
        this.$emit('successPost', id);
      },
      deleteInterview(id) {
        this.$emit('deleteInterview', id);
      },
      interviewReject(index) {
        this.$emit('interviewReject', index);
      },
      downloadResume() {
        const item = this.item;
        this.$emit('downloadResume', this.type === 'talent' ? item.id : item.workerId, item.isColl, item.name, item.recruitId);
      },
      qppCollWorkerInterview(workerId, recruitId) {
        this.$emit('qppCollWorkerInterview', workerId, recruitId);
      },
      appInterviewSuccess(id) {
        this.$emit('appInterviewSuccess', id);
      },
      interviewFailView(id) {
        this.$emit('interviewFailView', id);
      }
    }
  }
</script>

<style lang="less" scoped>
  @import url('../assets/less/base.less');

  .resumeboxs {
    position: relative;
    padding-bottom: 18px;
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 24px;

    .head-image {
      width: 84px;
      height: 84px;
      border-radius: 2px;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tit-name {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
      font-weight: 500;
      color: #222222;
      line-height: 28px;
      margin-bottom: 7px;
    }

    .tit-post {
      font-size: 18px;
      font-weight: 400;
      color: #222222;
      line-height: 25px;
      margin-bottom: 6px;

      .tit-sub {
        width: 86px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: #FFF1F0;
        border-radius: 2px;
        border: 1px solid #FF4D4F;
        color: #FF4D4F;
        font-size: 12px;
      }

      .light {
        color: #555555;
        margin-right: 8px;
      }

      .v-line {
        width: 1px;
        height: 22px;
        background: #222;
        margin: 0 10px;
      }
    }

    .detail-ls {
      color: #989898;
      padding: 3px 0;

      > div {
        border-right: 1px solid #989898;
        padding-right: 10px;
        margin-right: 10px;
        font-size: 14px;
        line-height: 14px;

        &:last-of-type {
          border-right: 0;
        }
      }
    }

    .btn-ls {
      margin-left: 120px;
      width: 120px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #333333;

      .primary-btn {
        width: 100%;
        display: block;
        margin-bottom: 10px;
      }
    }

    .time {
      position: absolute;
      top: 0;
      right: 0;
      color: #BDBDBD;
      font-size: 12px;
    }

    .resume-btn-groups {
      position: absolute;
      bottom: 10px;
      right: 0;
      display: flex;
      justify-content: flex-end;
      align-content: center;

      .resumebtn {
        width: 90px;
        height: 30px;
        line-height: 30px;
        padding: 0 16px;
        margin-left: 24px;
        font-size: 14px;
      }
    }
  }

  .from-out {
    height: 24px;
    padding: 0 10px;
    line-height: 24px;
    text-align: center;
    background: linear-gradient(90deg, rgba(26, 175, 253, 0.3) 0%, rgba(26, 175, 253, 0.09) 100%);
    border-radius: 12px 2px 12px 2px;
    font-size: 12px;
    color: #00A7FF;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// resumeItem.vue?a94f04d6